export enum ModuleGlobalState {
  Cluster= 'cluster',
  Service= 'service',
  ClusterService= 'clusterservice',
  NoState = 'none',
  Unknown= 'unknown'
}
